app.controller(
    'ListController', ['$rootScope', '$scope', '$timeout', '$http', 'toastr', '$document', '$sce', 'HelperService', '$state', '$stateParams', 'tmhDynamicLocale', '$translate', ListController]

);

function ListController($rootScope, $scope, $timeout, $http, toastr, $document, $sce, HelperService, $state, $stateParams, tmhDynamicLocale, $translate) {
    $rootScope.LayoutWithSearch = true;    
    var vm = this;
    $scope.moduleState = 'list';
    $scope.type = '';
    $scope.ListIdSelected = []; //declare an empty array
    $scope.search = '';
    $scope.gsearch = '';
    $scope.qc = '';
    $scope.mcd = 'all';
    $scope.sortkey = '';
    $scope.reversesort = false;

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
       
    }

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    tmhDynamicLocale.set($rootScope.LangForInterface);

    $scope.showDetail = function (page) {
        $scope.moduleState = page;
        $timeout(
            function () {
                angular.element(document.getElementById('container-list')).addClass('sidenav__edit--is-open');
                $timeout(
                    function (event) {
                        $scope.show = true;
                    }
                );

            }
        )

    };
    $scope.closeDetail = function (page) {
        $scope.moduleState = page;
        $timeout(
            function () {
                angular.element(document.getElementById('container-list')).removeClass('sidenav__edit--is-open');
                $timeout(
                    function (event) {
                        $scope.show = false;
                    }
                );

            }
        )

    };
    $scope.config = {
        // autoHideScrollbar: false,
        setHeight: 500,
    };

    /**
     * Close sidebar menu
     * @method

     * @return {[type]} [description]
     */
    $scope.close = function () {
        angular.element(document.getElementById('container-list')).removeClass('sidenav__edit--is-open');
    };

    $scope.scrollLeftInd = 0;

    var scrollHorizontal = function ($event, direction, nbScroll) {
        var parent = $($event.target).closest('.systeme_onglets'),
            onglets = parent.find('.onglets-container'),
            current = onglets.scrollLeft();
        if (direction == 'right') {
            $scope.scrollLeftInd = current + 300;
        } else {
            $scope.scrollLeftInd = current - 300;
        }
        $(onglets).animate({
            scrollLeft: $scope.scrollLeftInd
        }, 300);

    };

    $scope.scrollToLeft = function ($event) {
        scrollHorizontal($event, 'left');
    };

    $scope.scrollToRight = function ($event) {
        scrollHorizontal($event, 'right');
    };


    $scope.$on(
        '$viewContentLoaded',
                function () {
                    menu();
                    $timeout(
                        function () {
                        }, 100
                    );

                }
    );
    $scope.ExportWord = function () {
        HelperService.ExportWord('z=' + vm.ParamZoneId,'urlexport');
    };

    // [Lam Hong 13-Jan-2026] LVCG-213: [Places list export] Integrate existing python place listing to BO
    $scope.ExportExcel = function () {
        HelperService.ExportExcel(vm.ParamZoneId);
    };

    $scope.ExportGenericWord = function() {
        
        HelperService.ExportWordGeneric(vm.ParamZoneId, $rootScope.LangForInterface,$rootScope.LangForWork, $scope.type, $scope.search, $scope.gsearch, $scope.qc, $rootScope.SelectedListId[$scope.type], $scope.mcd, $scope.sortkey, $scope.reversesort);
    };

    $scope.ExportInDesign = function () {
        HelperService.ExportInDesign(vm.ParamZoneId);
        toastr.success($translate.instant("VotreDemandeExportInDesignConfirmation"));
    };
}
